export default __webpack_public_path__ + "assets/images/OA_Seal_FullColor.png";